import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class LineItemProps extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateLineItemProps);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateLineItemProps);
    }

    /**
     * Updates the final sale message and line item property.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    updateLineItemProps = (event) => {
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
        }

        const newItemProps = event.detail.data.html.querySelector('line-item-props [ref="lineItemPropsContainer"]');
        const currentItemProps = this.querySelector('[ref="lineItemPropsContainer"]');
        if (!newItemProps || !currentItemProps) return;

        if (currentItemProps.innerHTML !== newItemProps.innerHTML) {
            currentItemProps.replaceWith(newItemProps);
        }
    };
}

if (!customElements.get('line-item-props')) {
    customElements.define('line-item-props', LineItemProps);
}
